import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Header from '../components/header'
import AppComponent from '../components/404'
import Footer from '../components/footer'
import './page.css'

const Page = (props) => {
  return (
    <div className="page-container">
      <Helmet>
        <title>
          Page - Stefan Lacher | Software Solutions for Web, Apps & Data
        </title>
        <meta
          name="description"
          content="I create tailored software solutions for Web, Mobile and Data — from modern websites to scalable cloud systems. Based in Austria, working globally."
        />
        <meta
          property="og:title"
          content="Page - Stefan Lacher | Software Solutions for Web, Apps &amp; Data"
        />
        <meta
          property="og:description"
          content="I create tailored software solutions for Web, Mobile and Data — from modern websites to scalable cloud systems. Based in Austria, working globally."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/50551946-307e-48ab-899a-950ab7a25dad/6b02e41a-da5a-475f-a28c-27c456397767?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <Header
        textAbout={
          <Fragment>
            <span className="page-text10">About</span>
          </Fragment>
        }
        textContact={
          <Fragment>
            <span className="page-text11">Contact</span>
          </Fragment>
        }
        textProjects={
          <Fragment>
            <span className="page-text12">Projects</span>
          </Fragment>
        }
        textServices={
          <Fragment>
            <span className="page-text13">Services</span>
          </Fragment>
        }
        textAboutMobile={
          <Fragment>
            <span className="page-text14">About</span>
          </Fragment>
        }
        textContactMobile={
          <Fragment>
            <span className="page-text15">Contact</span>
          </Fragment>
        }
        textProjectsMobile={
          <Fragment>
            <span className="page-text16">Projects</span>
          </Fragment>
        }
        textServicesMobile={
          <Fragment>
            <span className="page-text17">Services</span>
          </Fragment>
        }
      ></Header>
      <AppComponent
        title404={
          <Fragment>
            <span className="page-text18">Diese Seite ist verschollen.</span>
          </Fragment>
        }
        text404={
          <Fragment>
            <span className="page-text19">
              <span>
                Wir haben alles durchwühlt, aber die gesuchte Seite nicht
                gefunden. Vielleicht können wir aber ein besseres Ziel für dich
                finden.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        button404Home={
          <Fragment>
            <span className="page-text22">Zur Startseite</span>
          </Fragment>
        }
      ></AppComponent>
      <Footer
        textMade={
          <Fragment>
            <span className="page-text23">Made with</span>
          </Fragment>
        }
        textName={
          <Fragment>
            <span className="page-text24">Stefan Lacher</span>
          </Fragment>
        }
        textYear={
          <Fragment>
            <span className="page-text25">© 2025</span>
          </Fragment>
        }
        textContact={
          <Fragment>
            <span className="page-text26">Contact</span>
          </Fragment>
        }
        textImpressum={
          <Fragment>
            <span className="page-text27">Impressum</span>
          </Fragment>
        }
        textPrivacyPolicy={
          <Fragment>
            <span className="page-text28">Privacy Policy</span>
          </Fragment>
        }
      ></Footer>
    </div>
  )
}

export default Page
